import React, { useEffect } from 'react'
import Header from '../../../headerone/Main'
import Bredcom from '../../../Bredcom/Main'
import FamilyCommunityHealthDetails from '../../subdepartmentdetails/FamilyCommunityHealth'


function FamilyCommunityHealth() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Family and Community Health Programs || Health and Human Services";
  }, [])


  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
        <Bredcom 
            subtitle="Health Human Services"
            title="Family & Community Health Programs"
            subtitledown="Department of Health & Human Services"
           />
            <FamilyCommunityHealthDetails/>
        </div>
    </>
  )
}

export default FamilyCommunityHealth